import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Fab from "@material-ui/core/Fab";
import Fade from "@material-ui/core/Fade";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Popover from "@material-ui/core/Popover";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DoneIcon from "@material-ui/icons/Done";
import React, { useEffect, useState } from "react";
import BlockIcon from "@material-ui/icons/Block";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },

  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  backdrop: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: "-webkit-fill-available",
    overflowY: "scroll",
  },
  checkBoxStyle: {
    color: "red",
    fontSize: "larger",
  },
  switchForUser: {
    marginLeft: theme.spacing(1),
  },
  userErrorPopup: {
    border: "0.5px solid black",
    borderRadius: "10px",
    margin: "5px",
    padding: "10px",
    display: "none",
  },
}));

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export default function UserDetailsForm(props) {
  const classes = useStyles();
  const [userExcluded, triggerUserExclude] = React.useState(false);
  {
    /*............................................|...............
  ..............array to store group details.....\|/..............
  ................................................V...............*/
  }
  const [groupDetails, setGroupDetails] = React.useState([
    { fullName: "", phoneNo: "", gender: "" },
  ]);
  {
    /*................................................|...............
  ..............object to store values from form.....\|/..............
  ....................................................V...............*/
  }
  const [state, setState] = React.useState({
    fullName: "",
    phoneNo: " ",
    email: "",
    gender: "",
    idProof: "",
    event: { eventId: 1 },
    bookingType: "",
    noOfPeople: "1",
    bookingId: "",
    bookingDate: "",
    detailsOfPeople: groupDetails,
    message: 1,
  });

  {
    /*.......................................................|...............
  ...........toggle group button based on no. of tickets....\|/..............
  ...........................................................V...............*/
  }
  const [groupButtonDisabled, disableGroupButton] = React.useState(true);
  {
    /*.......................................................|...............
  ...........open group modal to take group details.........\|/..............
  ...........................................................V...............*/
  }
  const [groupModal, openGroupModal] = React.useState(false);

  const [errorText, setErrorText] = useState([]);

  const [noOfTickets, setNumberOfTickets] = React.useState("1"); //...................set ticket count.........................................
  const [multiTicketCount, updateTicketCount] = React.useState("false"); //...........to disable or enable no. of tickets field................
  const [anchorEl, setfileFormatWarning] = React.useState(null); //...................file format popper.......................................
  const [userChoice, disableUserChoice] = React.useState(true);

  {
    /*....................................................................|...............
  .........main form fields error checkers and message setters below.....\|/..............
  ........................................................................V...............*/
  }
  const [userNameError, triggerUserNameError] = React.useState(false);
  const [userNameErrorMsg, setUserNameErrorMsg] = React.useState("");
  const [mobNumError, triggerMobNumError] = React.useState(false);
  const [mobNumErrorMsg, setMobNumErrorMsg] = React.useState("");
  const [emailError, triggerEmailError] = React.useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = React.useState("");
  const [idCardError, setidCardError] = React.useState(false);
  const [genderError, setgenderError] = React.useState(false);
  const [regTypeError, setregTypeError] = React.useState(false);
  const [noOfTicketsError, triggerNoOfTicketsError] = React.useState(true);
  const [noOfTicketsErrorMsg, setNoOfTicketsErrorMsg] = React.useState("");
  const [groupAddButtonError, setGroupAddButtonError] = React.useState(true);

  {
    /*...............................................................^...............
  .........main form error checkers and message setters above......./|\..............
  ...................................................................|...............*/
  }

  {
    /*..............................................................|...............
  .........to toggle if user wants his own registration or not.....\|/..............
  ..................................................................V...............*/
  }

  const [userInclude, setuserInclude] = React.useState({
    checkedB: true,
  });

  const [groupMembersCount, setGroupMembersCount] = React.useState(
    parseInt(state.noOfPeople)
  );

  const [checkBox, setCheckBox] = React.useState({
    checkedB: false,
  });
  const [disableCheckBox, setDisableCheckBox] = React.useState(true);
  const [nextButtonDisable, setNextButtonDisable] = React.useState(true);
  {
    /*..............................................................................|...............
       ............final method called with checkbox action to do neccessary.......\|/..............
       ............actions before passing values to detailsPreview component........V...............*/
  }
  const handleConfirmCheckChange = (event) => {
    setCheckBox({ ...checkBox, [event.target.name]: event.target.checked });

    checkAllValuesToEnableNextButton();
  };
  const checkAllValuesToEnableNextButton = () => {
    {
      /*.....................................................................................|...............
         ............check if all fields are properly filled then enable next button........\|/..............
         ....................................................................................V...............*/
    }
    let mobilefield = document.getElementById("phoneNo");
    let ticketfield = document.getElementById("noOfPeople");
    let regtypefield = document.getElementById("bookingType");

    let flag = 0;

    if (state.fullName === "") {
      setNextButtonDisable(true);
      flag = 1;
      triggerUserNameError(true);
    }
    if (mobilefield.value === "") {
      setNextButtonDisable(true);
      flag = 1;
      triggerMobNumError(true);
    }
    if (state.email === "") {
      setNextButtonDisable(true);
      flag = 1;
      triggerEmailError(true);
    }
    if (state.gender === "") {
      setNextButtonDisable(true);
      flag = 1;
      setgenderError(true);
    }
    if (state.idProof === "") {
      setNextButtonDisable(true);
      flag = 1;
      setidCardError(true);
    }
    if (regtypefield.value === "") {
      setNextButtonDisable(true);
      flag = 1;
      setregTypeError(true);
    }

    if (state.bookingType !== "SELF") {
      setNextButtonDisable(true);
      if (ticketfield.value === "") {
        setNextButtonDisable(true);
        flag = 1;
        triggerNoOfTicketsError(true);
      }
      if (ticketfield.value !== state.detailsOfPeople.length) {
        setNextButtonDisable(true);
      } else {
        setGroupAddButtonError(false);

        setCheckBox({ ...checkBox, checkedB: true });
        setNextButtonDisable(false);
      }
      if (groupAddButtonError === true) {
        setNextButtonDisable(true);
        flag = 1;
        setCheckBox({ ...checkBox, checkedB: false });
      } else if (groupAddButtonError === false) {
        if (flag === 1) {
          setNextButtonDisable(true);
        } else {
          setCheckBox({ ...checkBox, checkedB: true });
          setNextButtonDisable(false);
        }
      }
    } else if (flag === 0) {
      setCheckBox({ ...checkBox, checkedB: true });
      setNextButtonDisable(false);
    } else {
      flag = 0;
    }
  };

  {
    /*......................................................................|...............
       ............dummy method to perform testing with form values........\|/..............
       .....................................................................V...............*/
  }
  // const showResults = () => {
  //   console.log("state is: ", state);
  // };

  const handleUserName = (event) => {
    event.preventDefault();

    groupDetails[0].fullName = event.target.value.toLowerCase();

    if (!/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/i.test(event.target.value)) {
      triggerUserNameError(true);
      setUserNameErrorMsg("invalid username");
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else {
      triggerUserNameError(false);
      setUserNameErrorMsg("");
      setState({
        ...state,
        [event.target.name]: event.target.value,
      });
      setDisableCheckBox(false);
      setCheckBox({ ...checkBox, checkedB: false });
    }
  };
  const handleMobileNumber = (event) => {
    event.preventDefault();
    groupDetails[0].phoneNo = event.target.value;
    if (event.target.value.length > 10) {
      triggerMobNumError(true);
      setMobNumErrorMsg("Incorrect number!");
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (/^[7|8|9]{10}$/i.test(event.target.value)) {
      triggerMobNumError(true);
      setMobNumErrorMsg("Invalid number!!");
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (!/^[789]{1}[0-9]{9}$/i.test(event.target.value)) {
      triggerMobNumError(true);
      setMobNumErrorMsg(
        "valid number start with 7,8 or 9/ it should be a 10  digit number"
      );
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else {
      triggerMobNumError(false);
      setMobNumErrorMsg("");
      setState({ ...state, [event.target.name]: event.target.value });
      setDisableCheckBox(false);
      setCheckBox({ ...checkBox, checkedB: false });
    }
  };
  const handleEmail = (event) => {
    event.preventDefault();
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(event.target.value)) {
      triggerEmailError(true);
      setEmailErrorMsg("invalid email format");
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else {
      triggerEmailError(false);
      setEmailErrorMsg("");
      setState({ ...state, [event.target.name]: event.target.value });
      setDisableCheckBox(false);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    }
  };
  const handleGender = (event) => {
    event.preventDefault();
    groupDetails[0].gender = event.target.value;
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
    setgenderError(false);
    setDisableCheckBox(false);
    setCheckBox({ ...checkBox, checkedB: false });
  };
  async function handleIDcard(event) {
    event.preventDefault();
    let eventTarget = event.target;
    let file = eventTarget.files[0];

    if (file.size <= 500000) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      let base_64Link = "";
      reader.onload = () => {
        base_64Link = reader.result;
      };
      let spinElement = document.getElementById("imageLoadSpinner");
      let uploadComplete = document.getElementById("idcardUploadComplete");
      let uploadFailed = document.getElementById("idcardUploadFailed");
      uploadFailed.style.display = "none";
      spinElement.style.display = "inline-block";
      await sleep(1500);
      spinElement.style.display = "none";
      uploadComplete.style.display = "inline-block";

      setDisableCheckBox(false);
      setCheckBox({ ...checkBox, checkedB: false });
      setState({ ...state, [eventTarget.name]: base_64Link });
      setidCardError(false);
      setNextButtonDisable(true);
    } else {
      let uploadFailed = document.getElementById("idcardUploadFailed");
      uploadFailed.style.display = "inline-block";
      alert(`file size should be less than 500kb`);
      setDisableCheckBox(true);
      setCheckBox({ ...checkBox, checkedB: false });
      setState({ ...state, [eventTarget.name]: "" });
      setidCardError(true);
      setNextButtonDisable(true);
    }
  }

  const handlePopoverOpen = (event) => {
    setfileFormatWarning(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setfileFormatWarning(null);
  };
  const open = Boolean(anchorEl);
  //   const handleRegType = (event) => {   //..............................implemented in handleTicketCountField handler..........
  //     event.preventDefault();
  //     setState({ ...state, [event.target.name]: event.target.value });
  //   };
  const handleTicketCountField = (event) => {
    let elem = document.getElementById("noOfPeople");
    event.preventDefault();
    setNextButtonDisable(true);
    setState({
      ...state,
      [event.target.name]: event.target.value, //...........................setting registration type here.........................
    });
    setCheckBox({ ...checkBox, checkedB: false });

    if (event.target.value === "SELF") {
      setState({
        ...state,
        [event.target.name]: event.target.value,
        [elem.name]: 1,
        message: "",
      });
      updateTicketCount("false");
      setDisableCheckBox(false);
      disableUserChoice(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (event.target.value === "NONE") {
      updateTicketCount("false");
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      disableUserChoice(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else {
      if (
        event.target.value === "GROUP" ||
        event.target.value === "CORPORATE"
      ) {
        if (parseInt(state.noOfPeople) === 1) {
          disableGroupButton(true);
          triggerNoOfTicketsError(true);
          setNoOfTicketsErrorMsg("Should be more than 1");
        }
      }
      if (event.target.value === "OTHER" && state.noOfPeople >= 1) {
        disableGroupButton(false);
        triggerNoOfTicketsError(false);
        setNoOfTicketsErrorMsg("");
      }
      updateTicketCount("true");
      disableUserChoice(false);
      setCheckBox({ ...checkBox, checkedB: false });
      setregTypeError(false);
    }
  };
  const handleTickets = (event) => {
    event.preventDefault();

    if (event.target.value < 0) {
      triggerNoOfTicketsError(true);
      setNoOfTicketsErrorMsg("ticket number can't be negative");
      disableGroupButton(true);
      setGroupAddButtonError(true);
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (event.target.value === "-") {
      triggerNoOfTicketsError(true);
      setNoOfTicketsErrorMsg("ticket number can't be negative");
      disableGroupButton(true);
      setGroupAddButtonError(true);
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (
      event.target.value < 2 &&
      (state.bookingType === "GROUP" || state.bookingType === "CORPORATE")
    ) {
      triggerNoOfTicketsError(true);
      setNoOfTicketsErrorMsg("Should be more than 1");
      disableGroupButton(true);
      setDisableCheckBox(true);
      setGroupAddButtonError(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (state.bookingType === "OTHER" && event.target.value >= 1) {
      setState({ ...state, [event.target.name]: event.target.value });
      triggerNoOfTicketsError(false);
      setNoOfTicketsErrorMsg("");
      disableGroupButton(false);
      setNumberOfTickets(event.target.value);
      setGroupAddButtonError(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (
      /^[a-zA-Z]+$/i.test(event.target.value) ||
      isNaN(event.target.value)
    ) {
      triggerNoOfTicketsError(true);
      setNoOfTicketsErrorMsg("it should be a number");
      disableGroupButton(true);
      setDisableCheckBox(true);
      setGroupAddButtonError(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else if (event.target.value > 10) {
      {
        /*..................................................................|...............
      .........restrict the maximum number of people in the group here.....\|/..............
      ......................................................................V...............*/
      }
      disableGroupButton(true);
      triggerNoOfTicketsError(true);
      setGroupAddButtonError(true);
      setNoOfTicketsErrorMsg(
        "you can book ticket for max. 10 people(including you)"
      );
      setDisableCheckBox(true);
      setNextButtonDisable(true);
      setCheckBox({ ...checkBox, checkedB: false });
    } else {
      if (parseInt(event.target.value) === state.detailsOfPeople.length) {
        setGroupAddButtonError(false);
      }

      triggerNoOfTicketsError(false);
      setNoOfTicketsErrorMsg("");
      disableGroupButton(false);
      setNumberOfTickets(event.target.value);
      setState({ ...state, [event.target.name]: event.target.value });
      setDisableCheckBox(false);
      setCheckBox({ ...checkBox, checkedB: false });
    }
  };

  const handleGroupModalOpen = () => {
    setGroupAddButtonError(true);
    if (groupMembersCount < state.detailsOfPeople.length) {
      groupDetails.length = 1;
    }

    if (state.message === "") {
      let initialCount = parseInt(state.noOfPeople);
      setGroupMembersCount(initialCount + 1);
    } else {
      setGroupMembersCount(state.noOfPeople);
    }
    openGroupModal(true);

    setCheckBox({ ...checkBox, checkedB: false });
  };

  const handleGroupModalClose = () => {
    openGroupModal(false);
    let elem = document.getElementById("errorPopup");

    if (parseInt(groupMembersCount) === state.detailsOfPeople.length) {
      let flag = 0;
      groupDetails.map((k, i) => {
        if (
          k.fullName === undefined ||
          k.phoneNo === undefined ||
          k.gender === undefined ||
          k.fullName === "" ||
          k.phoneNo === "" ||
          k.gender === ""
        ) {
          flag = 1;
        } else {
          flag = 0;
        }
      });
      if (flag === 1) {
        setGroupAddButtonError(true);
        disableGroupButton(false);
      } else {
        setGroupAddButtonError(false);
        disableGroupButton(true);
      }
    } else {
      setGroupAddButtonError(true);
      elem.style.display = "none";
    }
  };

  useEffect(() => {
    setGroupDetails(groupDetails);
    setState((prevState) => ({ ...prevState, detailsOfPeople: groupDetails }));
  }, [groupDetails]);

  function handleChange(event, index) {
    if (event.target.name === "phoneNo") {
      let inputVal = event.target.value;
      if (isNaN(inputVal) || /^[7|8|9]{10}$/i.test(inputVal)) {
        let arr = [...errorText];
        arr[index - 1] = "Invalid " + event.target.name;
        setErrorText(arr);
      } else if (inputVal.length > 10) {
        let arr = [...errorText];
        arr[index - 1] = "Incorrect Number!";
        setErrorText(arr);
      } else if (!/^[789]{1}[0-9]{9}$/i.test(inputVal)) {
        let arr = [...errorText];
        arr[index - 1] = "Maintain the format!";
        setErrorText(arr);
      } else {
        let arr = [...errorText];
        arr[index - 1] = "";
        setErrorText(arr);
      }
    }
    let newArr = [...groupDetails];
    let item = newArr[index];
    item = { ...item, [event.target.name]: event.target.value };
    newArr[index] = item;
    setGroupDetails(newArr);
  }

  const handleUserInclude = (event) => {
    setuserInclude({
      ...userInclude,
      [event.target.name]: event.target.checked,
    });
    if (event.target.checked === true) {
      //..............user is a part of the registration.............
      setState({
        ...state,
        message: 1,
      });
    } else {
      //..............user is not a part of the registration.........
      triggerUserExclude(true);
      setState({
        ...state,
        message: "",
      });
    }
  };

  const formTransition = () => {
    props.getFormValues(state); //..............to pass form values to parent...........................................
    props.triggerParentMethod(); //.............trigger handleNext method of parent to go to detailsPreview.jsx.........
  };

  return (
    <React.Fragment>
      <FormGroup>
        <Typography variant="h6" gutterBottom>
          Details required for registration
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              required
              id="fullName"
              name="fullName"
              label="Full name"
              fullWidth
              autoComplete="fname"
              autoFocus
              onChange={handleUserName}
              error={userNameError ? true : false}
              helperText={userNameErrorMsg}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id="phoneNo"
              name="phoneNo"
              label="Mobile Number"
              fullWidth
              autoComplete="phoneNo"
              error={mobNumError ? true : false}
              helperText={mobNumErrorMsg}
              onChange={handleMobileNumber}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              error={emailError ? true : false}
              helperText={emailErrorMsg}
              onChange={handleEmail}
              id="email"
              name="email"
              label="E-mail ID"
              fullWidth
              autoComplete="email"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              error={genderError ? true : false}
              native
              id="gender"
              name="gender"
              label="Gender"
              fullWidth
              autoComplete="gender"
              select
              onChange={handleGender}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Others</option>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <input
              required
              className={classes.input}
              accept="image/*"
              name="idProof"
              id="idProof"
              type="file"
              accept="image/png, image/jpeg"
              onChange={handleIDcard}
            />
            <label htmlFor="idProof">
              <Button
                startIcon={<CloudUploadIcon />}
                name="idProof"
                id="idProof"
                variant="contained"
                color={idCardError ? "secondary" : "default"}
                component="span"
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              >
                Upload ID card
              </Button>
              &nbsp; &nbsp;
              <div
                id="imageLoadSpinner"
                style={{ display: "none" }}
                className="spinner-border text-success"
              ></div>
              <div id="idcardUploadComplete" style={{ display: "none" }}>
                <DoneIcon color="success" />
              </div>
              <div id="idcardUploadFailed" style={{ display: "none" }}>
                <BlockIcon color="success" />
              </div>
              <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                  paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
              >
                <Typography variant="caption">
                  file format *jpeg and *png only and file size less than 500 kb
                </Typography>
              </Popover>
            </label>
          </Grid>
          <Grid item xs={12}>
            <TextField
              native
              error={regTypeError ? true : false}
              required
              id="bookingType"
              name="bookingType"
              label="Registration Type"
              fullWidth
              autoComplete="registrationType"
              onChange={handleTicketCountField}
              select
            >
              <option value="SELF">Self</option>
              <option value="GROUP">Group</option>
              <option value="CORPORATE">Corporate</option>
              <option value="OTHER">Others</option>
            </TextField>
          </Grid>
          <Typography color="primary" className={classes.switchForUser}>
            You want your own registration for the event?
          </Typography>

          <Grid item xs={12}>
            <span>NO</span>
            <Switch
              disabled={userChoice ? true : false}
              checked={userInclude.checkedB}
              onChange={handleUserInclude}
              name="checkedB"
              color="primary"
            />
            <span>YES</span>
          </Grid>
          {multiTicketCount === "false" ? (
            <Grid item xs={12}>
              <TextField
                id="noOfPeople"
                name="noOfPeople"
                label="Number of Tickets"
                fullWidth
                value="1"
                autoComplete="1"
                defaultValue="1"
                disabled
              />
            </Grid>
          ) : (
            <React.Fragment>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  id="noOfPeople"
                  name="noOfPeople"
                  label="Total Number of Tickets"
                  fullWidth
                  autoComplete="noOfPeople"
                  onChange={handleTickets}
                  error={noOfTicketsError ? true : false}
                  helperText={noOfTicketsErrorMsg}
                />
                <Typography color="#000000" variant="caption">
                  Decreasing this value after completely filling the group form
                  will make it empty!
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Fab
                  disabled={groupButtonDisabled ? true : false}
                  variant="extended"
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={handleGroupModalOpen}
                  color={groupAddButtonError ? "secondary" : "default"}
                >
                  <AddIcon />
                  Add other members details
                </Fab>
                <Typography
                  color="secondary"
                  id="errorPopup"
                  className={classes.userErrorPopup}
                >
                  You need to fill all the details of all the members!
                  <img
                    style={{ width: "30px", transform: "rotate(180deg)" }}
                    src="./images/downArrow.gif"
                    alt=""
                  />
                </Typography>
              </Grid>
            </React.Fragment>
          )}

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckBox ? true : false}
                  checked={checkBox.checkedB}
                  onChange={handleConfirmCheckChange}
                  name="checkedB"
                  color="primary"
                />
              }
              label={
                <Typography
                  className={classes.checkBoxStyle}
                  variant="caption2"
                >
                  You declare that the information entered is true to your
                  knowledge
                </Typography>
              }
            />
          </Grid>
          <Button
            disabled={nextButtonDisable ? true : false}
            variant="contained"
            color="primary"
            values={state}
            onClick={formTransition}
            className={classes.button}
          >
            Next
          </Button>
          {/*.........................................................|...............
             .....dummy button to check form values being passed.....\|/..............
             .....to next component, in console.......................V...............
             .........................................................................*/}
          {/* <Button onClick={showResults}>Show results</Button> */}
        </Grid>

        {/*..............................................^.............................
             .....BASIC FORM INPUTS COMPLETED HERE,...../|\............................
             ............................................|.................|...........
             .....BELOW IS THE MODAL THAT TAKES GROUP MEMBERS DETAILS.....\|/..........
             ..............................................................V...........*/}

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={groupModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={groupModal}>
            <div className={classes.backdrop}>
              <h2 id="transition-modal-title">Group members details</h2>
              <p id="transition-modal-description">
                Total number of tickets asked for: {noOfTickets}
              </p>
              <div>
                <hr />
                <strong>Member #1</strong> (All the tickets will be sent to this
                person)
                <p style={{ fontSize: "11px", color: "red" }}>
                  You need to fill the main form to see this
                </p>
                {userExcluded ? (
                  <Typography color="secondary">
                    Please note: This member is not included in the booking
                  </Typography>
                ) : null}
                <div>
                  <TextField
                    disabled
                    variant="outlined"
                    margin="none"
                    style={{ width: "33%" }}
                    label="Full Name"
                    value={state.detailsOfPeople[0].fullName}
                    autoComplete={state.detailsOfPeople[0].fullName}
                  />
                  <TextField
                    disabled
                    variant="outlined"
                    margin="none"
                    style={{ width: "33%" }}
                    label="Mobile Number"
                    value={state.detailsOfPeople[0].phoneNo}
                    autoComplete={state.detailsOfPeople[0].fullName}
                  />
                  <TextField
                    disabled
                    variant="outlined"
                    margin="none"
                    style={{ width: "33%" }}
                    label="Gender"
                    value={state.detailsOfPeople[0].gender}
                    autoComplete={state.detailsOfPeople[0].fullName}
                  />
                </div>
                <br />
                {/*..........................................|...............
                   ..............multiple group details.....\|/..............
                   ..........................................V...............*/}
                {Array.apply(null, { length: groupMembersCount - 1 }).map(
                  (e, i) => (
                    <div key={i}>
                      <strong>Member #{i + 2}</strong>
                      <br />
                      <div className="getFormBlock" name={i + 1}>
                        <TextField
                          id={`name${i + 1}`}
                          name="fullName"
                          variant="outlined"
                          margin="none"
                          style={{ width: "33%" }}
                          label="Full Name"
                          onChange={(event) => {
                            handleChange(event, i + 1);
                          }}
                          value={
                            groupDetails[i + 1]
                              ? groupDetails[i + 1].fullName
                              : ""
                          }
                        />
                        <TextField
                          id={`phoneNo${i + 1}`}
                          name="phoneNo"
                          variant="outlined"
                          margin="none"
                          style={{ width: "33%" }}
                          label="Mobile Number"
                          onChange={(event) => {
                            handleChange(event, i + 1);
                          }}
                          error={
                            errorText[i] !== "" && errorText[i] !== undefined
                          }
                          helperText={errorText[i]}
                          value={
                            groupDetails[i + 1]
                              ? groupDetails[i + 1].phoneNo
                              : ""
                          }
                        />
                        <Select
                          id={`gender${i + 1}`}
                          name="gender"
                          variant="outlined"
                          margin="none"
                          style={{ width: "33%" }}
                          label="Gender"
                          onChange={(event) => {
                            handleChange(event, i + 1);
                          }}
                          value={
                            groupDetails[i + 1]
                              ? groupDetails[i + 1].gender
                              : ""
                          }
                        >
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                          <option value="OTHER">Other</option>
                        </Select>
                      </div>
                      <br />
                    </div>
                  )
                )}
                {/*....................................................^...............
                   ..............multiple group details input end...../|\..............
                   ....................................................|...............*/}
                <div className="card-footer text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={handleGroupModalClose}
                  >
                    Done
                  </Button>
                </div>
                {/*....................................................^...............
                   .........multiple group details form ends here...../|\..............
                   ....................................................|...............*/}
              </div>
            </div>
          </Fade>
        </Modal>
      </FormGroup>
    </React.Fragment>
  );
}
